import { useEffect, useState } from 'react';
export const numberText = (n: number) => n.toLocaleString('tr-TR');
export const chipsText = (n: number) => `${numberText(n)} çip`;
export const bpsText = (n: number) => `${numberText(n)} bps · %${numberText(n / 100)}`;
const LABELS: Record<string, string> = {
  PURCHASE: 'Çip satın alma',
  REFUND: 'Satın alma iadesi',
  GRANT: 'Çip verme',
  BET_HOLD: 'Bahis blokesi',
  BET_RELEASE: 'Bloke çözümü',
  BET_SETTLE_WIN: 'Oyun kazancı',
  BET_SETTLE_LOSS: 'Oyun kaybı',
  BET_REFUND_SECOND: 'İkinciye bahis iadesi',
  TRANSFER_OUT: 'Gönderilen transfer',
  TRANSFER_IN: 'Alınan transfer',
  TRANSFER_FEE: 'Transfer ücreti',
  TRANSFER_REVERSAL: 'Transfer geri alımı',
  GIFT_ITEM_BUY: 'Hediye alımı',
  STORE_ITEM_BUY: 'Mağaza alımı',
  AD_REWARD: 'Reklam ödülü',
  DAILY_BONUS: 'Günlük bonus',
  EVENT_REWARD: 'Etkinlik ödülü',
  WHEEL_PRIZE: 'Çark ödülü',
  LEVEL_REWARD: 'Seviye ödülü',
  ADMIN_ADJUST: 'Yönetim düzeltmesi',
  CHARGEBACK_CLAWBACK: 'Ters ibraz geri alımı',
  active: 'Etkin',
  frozen: 'Donduruldu',
  banned: 'Banlı',
  deleted: 'Silindi',
  BONUS: 'Oyun çipi',
  PURCHASED: 'Satın alınan',
  GIFTED: 'Hediye alınan',
  ADMIN: 'Yönetici',
  SUPER_ADMIN: 'Üst yönetici',
  SUPPORT: 'Destek',
  FINANCE: 'Muhasebe',
  MODERATOR: 'Moderatör',
  chips: 'Çip',
  vip: 'VIP',
  cosmetic: 'Kozmetik',
  none: 'Boş',
  daily: 'Günlük',
  weekly: 'Haftalık',
  info: 'Bilgi',
  event: 'Etkinlik',
  maintenance: 'Bakım',
  open: 'Açık',
  dismissed: 'Reddedildi',
  actioned: 'İşlem yapıldı',
  all: 'Tümü',
  pending: 'Bekliyor',
  completed: 'Tamamlandı',
  failed: 'Başarısız',
  cancelled: 'İptal edildi',
  verified: 'Doğrulandı',
  refunded: 'İade edildi',
  revoked: 'Geri alındı',
  held: 'Bekletiliyor',
  settled: 'Hesaplandı',
  purchase: 'Satın alma',
  transfer: 'Transfer',
  reward: 'Ödül',
  adjustment: 'Düzeltme',
  admin_adjust: 'Yönetici düzeltmesi',
  bet: 'Bahis',
  payout: 'Kazanç',
  rake: 'Komisyon',
  global: 'Genel',
  room: 'Oda',
  playing: 'Oynanıyor',
  waiting: 'Bekliyor',
  ended: 'Bitti',
  STORE: 'Mağaza',
  PROMO: 'Promosyon',
  RAKE: 'Komisyon',
  BURN: 'Yakım',
  ESCROW: 'Masada tutulan',
  ios: 'iOS',
  android: 'Android',
  web: 'Web',
  transfers: 'Transferler',
  store: 'Mağaza',
  wheel: 'Çark',
  daily_bonus: 'Günlük bonus',
  chat: 'Sohbet',
  matchmaking: 'Eşleştirme',
};
export const enumText = (value: string) => LABELS[value] ?? `Diğer (${value})`;
export function StatusBadge({ value }: { value: string }) {
  return (
    <span
      className={`pill ${value === 'active' ? 'ok' : value === 'banned' ? 'sev-high' : 'neutral'}`}
    >
      {enumText(value)}
    </span>
  );
}
export const absoluteTime = (value: string | number | null | undefined) => {
  if (value == null || value === '') return '—';
  const date = new Date(value);
  return Number.isFinite(date.getTime())
    ? new Intl.DateTimeFormat('tr-TR', { dateStyle: 'short', timeStyle: 'long' }).format(date) +
        ` · ${Intl.DateTimeFormat().resolvedOptions().timeZone}`
    : 'Tarih bilinmiyor';
};
export function TimeText({ value }: { value: string | number | null | undefined }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(t);
  }, []);
  if (value == null || value === '') return <>—</>;
  const at = new Date(value).getTime();
  if (!Number.isFinite(at)) return <>Tarih bilinmiyor</>;
  const minutes = Math.round((at - now) / 60000);
  const unit = Math.abs(minutes) < 60 ? 'minute' : Math.abs(minutes) < 1440 ? 'hour' : 'day';
  const count = unit === 'minute' ? minutes : Math.round(minutes / (unit === 'hour' ? 60 : 1440));
  return (
    <time dateTime={new Date(at).toISOString()} title={absoluteTime(value)}>
      <span>{new Intl.RelativeTimeFormat('tr', { numeric: 'auto' }).format(count, unit)}</span>
      <small className="time-absolute">{absoluteTime(value)}</small>
    </time>
  );
}
